import { t } from 'i18next';
import { useMutation } from 'react-query';

import { NotificationPosition } from 'core/enums';
import { useHandleErrors } from 'core/hooks';
import { jobImportService } from 'jobs/services';

interface IProps {
  position?: NotificationPosition;
}

export const useJobImportActions = (props: IProps = {}) => ({
  ...useCreateJobImport(props),
});

const useCreateJobImport = ({ position = NotificationPosition.DRAWER }: IProps) => {
  const { errors } = useHandleErrors({
    loading: { message: t('messageJobImportCreateInProgress') },
    error: { title: t('errorTitleJobImportCreating') },
    position,
  });

  const { mutateAsync } = useMutation(jobImportService.createJobImport, {
    ...errors,
  });

  return { createJobImport: mutateAsync };
};
